import * as React from "react";
import { NativeTileShowcaseItemRegionProps } from "./typings";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { BlossomComponents } from "components/flexFramework/BlossomComponents/BlossomComponents";
import {
  BlossomComponentFactory,
  BlossomComponentFactoryProps,
} from "components/flexFramework/domain/BlossomComponentFactory";
import { SimpleContainerModel } from "components/flexComponents/SimpleContainer/typings";

export const NativeTileShowcaseItemRegion = (props: NativeTileShowcaseItemRegionProps) => {
  const blossomComponent = BlossomComponentFactory.get(props as BlossomComponentFactoryProps);
  const context = props.context;

  if (!blossomComponent) {
    return null;
  }

  const model = blossomComponent.getModel<SimpleContainerModel>();
  const { width } = model;

  return (
    <>
      <UitkLayoutFlexItem grow={width === "33" ? 0 : 1}>
        <div className={`NativeTileShowcaseItemRegion`}>
          <BlossomComponents blossomComponent={blossomComponent} context={context} />
        </div>
      </UitkLayoutFlexItem>
    </>
  );
};

export default NativeTileShowcaseItemRegion;
